import React, { Component } from 'react';

import { translate } from "react-translate";

import MenuComponent from '../MenuComponent';
import FooterComponent from '../FooterComponent';

import {
    Segment,
    Image,
    Header,
    Container,
    Divider
} from 'semantic-ui-react';
import './cguv.css';

import imageCgu from '../../../assets/img/cguv.png';

class CguvComponent extends Component {


    render() {

        const { t } = this.props;

        return (
            <div>
                <MenuComponent />
                <Segment vertical id="sectionCguv">
                    <Image
                        src={imageCgu}
                        id="sectionCguvImage"
                        fluid />
                    <div id="containerCguv">
                        <Container textAlign='center'>
                            <Header size='huge' as='h1' id="containerCguvTitre">{t("Segment1_title")}</Header>
                        </Container>

                        <Container textAlign='center'>
                            <p id="containerCguvDescription">
                                {t("Segment1_description")}
                            </p>
                        </Container>
                    </div>
                </Segment>

                <Segment vertical id="sectionCguvContent">
                    <Container>
                        <Header as='h3' size="huge" id="sectionCguvContentTitre">{t("Segment2_title")}</Header>
                    </Container>
                    <Container textAlign='center' >
                        <p id="sectionCguvContentLaw">
                            Conditions Générales d'Utilisation et de Ventes :

                            Quelque soit le domaine, les calculs sont fournis à titre indicatif et ne remplacent en aucun cas l'avis d'un professionnel du domaine concerné. Certains calculs ou conversions peuvent être inexacts, incomplets ou contenir des bugs de conception. Les utilisateurs qui trouvent une erreur peuvent le signaler directement sur le site ou au moyen de l'application.

                            En aucun cas, ni MyTravo ni ses auteurs ne peuvent être tenus pour légalement responsables d'une mauvaise utilisation ou compréhension de calcul, conversion ou information, d'un bug ou d'une erreur de l'application, qui auraient pu causer un préjudice, de quelques natures que ce soit à l'utilisateur ou à un tiers. MYTRAVO ne pourraît être tenu responsable, c'est à l'utilisateur de vérifier lui même les calculs et il est totalement responsable de l'exactitude des résultats, de l'utilisation qu'il en fait et de la réussite de son projet.

                            Certains calculs ou conversions s'appuient sur des données légales qui évoluent régulièrement. MYTRAVO met à jour régulièrement les données permettant de réaliser les calculs. Cependant il se peut que certains calculs ne soient pas à jour et donc ne respectent pas les règles légales en vigueur. Ces erreurs n'engagent en rien la responsabilité de MYTRAVO ou ses auteurs, les utilisateurs qui constatent qu'une donnée ou une information qui n'est pas en accord avec la loi/textes en vigueur sont invités à le signaler directement.

                            MYTRAVO ne collecte aucune information personnelle, ne conserve aucune donnée personnelle et ne diffuse aucun cookie.
                            Certains calculs peuvent être limités par la conception des outils informatique ou parce qu'ils sont trop complexes à traiter.
                            L'ensemble du site est régulièrement déposé par Copyright © et a fait l'objet d'un dépot à l' INPI.

                            Tout Utilisateur a la possibilité de se créer, gratuitement, un Compte. Il est interdit à un Utilisateur d’être titulaire de plusieurs Comptes. MYTRAVO se réserve le droit de désactiver tous les Comptes d’un Utilisateur qui ne respecterait pas cette règle.
                            Tout Utilisateur a la possibilité de se connecter à son Compte Utilisateur en créant un compte interne à MYTRAVO, avec son compte Facebook ou Google personnel.
                            Tout Utilisateur s’engage à respecter et à maintenir la confidentialité des identifiants de connexion à son Compte et reconnaît expressément que toute connexion à son Compte, ainsi que toute transmission de données depuis ledit Compte sera réputée avoir été effectuée par l’Utilisateur. Toute perte, détournement ou utilisation des identifiants de connexion et leurs éventuelles conséquences relèvent de la seule et entière responsabilité de l’Utilisateur.

                            GUIDIYAM se réserve le droit, à tout moment, de modifier ou interrompre l'accessibilité de tout ou partie du Service MYTRAVO et/ou du Site Internet.

                            GUIDIYAM se réserve la possibilité de modifier, à tout moment, en tout ou partie des CGUV. Les Utilisateurs sont invités à consulter régulièrement les présentes CGU afin de prendre connaissance de changements éventuels effectués. L'utilisation du Site Internet par les Utilisateurs, constitue l'acceptation par ces derniers des modifications apportées aux CGUV.

                            Si une partie des CGUV devait s'avérer illégale, invalide ou inapplicable, pour quelle que raison que ce soit, les dispositions en question seraient réputées non écrites, sans remettre en cause la validité des autres dispositions qui continueront de s'appliquer entre les Utilisateurs et Guidiyam.
                            Les présentes CGU sont soumises au droit français.
                        </p>
                    </Container>
                </Segment>

                <FooterComponent />
            </div>
        );
    }
}

export default translate("CguvComponent")(CguvComponent);



// WEBPACK FOOTER //
// ./src/components/Public/CguvPage/CguvComponent.js